import React from 'react';
import Loading from './Loading';

const LoadingScreen = () => {
  return (
    <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen">
      <div className="w-10 h-10">
        <Loading />
      </div>
    </div>
  );
};

export default LoadingScreen;
